import React from 'react';
import { Navigate } from 'react-router-dom'; // Use Navigate for redirection

// SECURITY NOTE: This is a CLIENT-SIDE guard only. It checks for a token in
// localStorage but does NOT validate it. Real authentication is enforced
// server-side via JWT verification in the auth middleware. This component
// only prevents unauthenticated UI rendering — it is NOT a security boundary.
const PrivateRoute = ({ element: Component, ...rest }) => {
  const token = localStorage.getItem('token');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <Component {...rest} />;
};

export default PrivateRoute;
